import "../styles/components/Footer.css"

/**
 * Footer component for all pages.
 */
const Footer = () => {
    return (
        <footer>
            <a href="https://www.rit.edu/womenincomputing/" target="__blank">&copy; RIT Women in Computing</a>
        </footer>
    );
};

export default Footer;